<template lang="pug">
    section#aproveitamento
        div.wrapper
            div.img
                img(:src="require('@images/transferencia/aproveitamento.png')", alt="Aproveitamento de estudos")
            div.texto
                p
                    |Mas, se você já tem uma Graduação e quer brilhar com a UniFAEL no seu segundo curso,
                    |você pode eliminar as disciplinas já cursadas com o APROVEITAMENTO DE ESTUDOS.
                    br
                    |Esta modalidade de ingresso também é válida para alunos que ainda não possuem uma graduação,
                    |mas já iniciaram um curso de ensino superior e perderam o vínculo ativo com a instituição há mais de 6 meses.

</template>

<script>
export default {
    name: "section-aproveitamento"
}
</script>

<style lang="stylus" scoped src="./Aproveitamento.styl"></style>
